
//根据路径获取 JSON 中的值。例如：selectJSON({a:{b:{c:1}}}, 'a.b.c');
function selectJSON(root, path) {
    if (typeof root[path] !== 'undefined')
        return root[path];
    let arr = path.split('.');
    let val = root;
    for(let i = 0;i < arr.length; i++) {
        let k = arr[i];
        if (typeof val[k] !== 'undefined') {
            val = val[k];
        }
        else {
            val = undefined;
            break;
        }
    }
    return val;
}

export default selectJSON